import { useTranslation } from 'react-i18next';
import BoldBlue from './BoldBlue';
import styled from 'styled-components';
import DynamicallyTranslatedText from './DynamicallyTranslatedText';

const FabricantContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 2px 0;

    margin-bottom: 10px;

    img {
        max-width: 13px;
        max-height: 13px;
        margin: 0;
    }
`;

const FabricantsDisplay = (props) => {

    const { i18n } = useTranslation('common');

    if(!props.fabricants) return null;

    let decodedFabricants = [];
    try {
        decodedFabricants = JSON.parse(props.fabricants);
    } catch (error) {
        console.log(error);
        decodedFabricants = [];
    }

    const removeFabricant = (index) => {
        decodedFabricants.splice(index,1);
        props.setFabricants(JSON.stringify(decodedFabricants));
    }

    //fabricants have a name, a "Travail réalisé", a contact and an email

    return (
        <>
            {decodedFabricants && decodedFabricants.length > 0 && <>
                <BoldBlue>{i18n.language === "fr" ? "Fabricants" : "Manufacturers"}</BoldBlue><br/>
                {decodedFabricants.map((fabricant,i) => {
                    return (
                        <FabricantContainer key={i}>
                            <div>
                                <BoldBlue>{i18n.language === "fr" ? "Nom :" : "Name:"}</BoldBlue> <span>{fabricant.name}</span><br/>
                                {/* <BoldBlue>{i18n.language === "fr" ? "Travail réalisé :" : "Work done:"}</BoldBlue> <span>{fabricant.work}</span><br/> */}
                                <BoldBlue>{i18n.language === "fr" ? "Travail réalisé :" : "Work done:"}</BoldBlue> <span><DynamicallyTranslatedText text={fabricant.work} targetLang={i18n.language} context={"Work done by a manufacturer"} /></span><br/>
                                <BoldBlue>{i18n.language === "fr" ? "Contact :" : "Contact:"}</BoldBlue> <span>{fabricant.contact}</span><br/>
                                <BoldBlue>{i18n.language === "fr" ? "Email :" : "Email:"}</BoldBlue> <span>{fabricant.email}</span><br/>
                            </div>
                            {props.setFabricants && <span style={{cursor:"pointer"}} onClick={() => removeFabricant(i)}><img src='/img/x_noir.png' alt='retirer' /></span>}
                        </FabricantContainer>
                    )
                })}
            </>}
            {props.inputName && <input hidden name={props.inputName} readOnly value={props.fabricants} />}
        </>
    );
};

export default FabricantsDisplay;
